import { useQuery } from '@apollo/client'
import { GetPatientHistoryTypesDocument } from './getPatientHistoryTypes.generated'

export function useGetPatientHistoryTypes(uid: string) {
  const { data } = useQuery(GetPatientHistoryTypesDocument, { variables: { uid } })
  return data?.patient?.program?.patientHistoryTypes
}
